import { useCallback } from 'react';
import api from '@/lib/api';
import { notificationFeed } from '@/lib/service-view-guards.mjs';
import { useVisibleResource } from '@/lib/useVisibleResource';

export function useNotificationFeed({ source = '', unreadOnly = false, limit = 12, poll = 0 } = {}) {
  const loader = useCallback(async signal => {
    const [list, counts] = await Promise.all([
      api.get('/notifications/center', { signal, timeout: 15000, params: { limit, source: source || undefined, unread_only: unreadOnly || undefined } }),
      api.get('/notifications/center/unread-count', { signal, timeout: 15000 }),
    ]);
    return notificationFeed(list.data, counts.data);
  }, [source, unreadOnly, limit]);
  return useVisibleResource(loader, poll);
}
